<template>
  <DropdownMenuTrigger
    v-if="!context.isMobile"
    :ref="forwardRef"
    as-child
    :data-dialog-id="context.id"
  >
    <slot></slot>
  </DropdownMenuTrigger>
  <DrawerTrigger v-else :ref="forwardRef" as-child :data-dialog-id="context.id">
    <slot></slot>
  </DrawerTrigger>
</template>

<script setup lang="ts">
import { DropdownMenuTrigger, useForwardExpose } from "reka-ui";
import { DrawerTrigger } from "vaul-vue";
import { onMounted } from "vue";

import { inject } from "./context";

const context = inject();

const { forwardRef, currentElement } = useForwardExpose();

onMounted(() => {
  context.triggerElement = currentElement;
});
</script>
